/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../../store/store';
import Filters from '../../../../../table/new/filters/Filters';
import Presets from '../../../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../../../table/new/TableWrapper';
import Columns from '../../../../../table/new/Columns';
import {baseFields} from '../../../../../table/new/customizationTable';
import BlankSheet from '../../../../../table/new/BlankSheet';
import FullScreen from '../../../../../table/new/FullScreen';
import Refresh from '../../../../../table/new/Refresh';
import ResultsCount from '../../../../../table/new/ResultsCount';
import Search from '../../../../../table/new/SearchForTable';

const Bayers = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  return (
    <PageWrapper
      prevTimeConfig={prevTimeConfig}
      firstTimeConfig='30day'
      breadcrumbs={[
        {title: 'Трекер'},
        {isSeparator: true},
        {title: 'Facebook'},
        {isSeparator: true},
        {title: 'Facebook Байера', path: '/tracker/facebook/bayers', isActive: true},
      ]}
      title={'Facebook Байера'}
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'Traffics/Facebook/Bayer/getStatistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
          {filter: 'traffic_id', isFixed: true, options: []},
        ]}
        defaultGroups={[{group: 'bayer', isFixed: true}]}
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields}
        disabledByDefault={[
          'click2reg',
          'click2cpa',
          'lead2fd',
          'lead2cpa',
          'chat2reg',
          'reg2cpa',
          'fd2cpa',
          'reg2rs',
          'chat2rs',
          'lead2rs',
          'click2rs',
        ]}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenNearGroups={<></>}
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns />
              <Presets />
              <FullScreen />
            </>
          }
          childrenHead={false}
          childrenRefresh={false}
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Bayers);
